import { from, map, Observable } from 'rxjs';

/**
 * Converts an object into a hashed key in the browser using SHA-256, wrapped in an Observable.
 * @param obj The object to hash.
 * @returns An Observable that emits a short, unique string key.
 */
export const objectToHashKey = (obj: object): Observable<string> => {
  const json = JSON.stringify(obj);
  const encoder = new TextEncoder();
  const data = encoder.encode(json);

  return from(crypto.subtle.digest('SHA-256', data)).pipe(
    map((hashBuffer) => {
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
    })
  );
};
